import Vue from 'vue';
import imagesLoaded from 'imagesloaded';

Vue.prototype.$imagesLoaded = imagesLoaded;
